<template>
  <div>
    <h1>Manage Maps</h1>
    <el-button @click="createMap" class="pull-right">Create Map</el-button>
    <el-dialog
        title="Create Map"
        :visible.sync="showModal"
        width="75%"
    >
      <FormManager
          @save="save"
          @cancel="showModal = false"
          :initialFormValues="editingMap"
          :events="events"
          prettyEndPoint="/api/maps/pretty" />
    </el-dialog>
    <el-table
        :data="maps"
        style="width: 100%">
      <el-table-column
          v-for = "column in columns"
          v-bind:label = column.label
          v-bind:prop = column.prop
          v-bind:width = column.width
      >
        <template slot-scope="scope">
            <span v-if="column.prop.toLowerCase() === 'match_type'">
                <span v-if="scope.row.match_type === 1">
                  Literal
                </span>
                <span v-else-if="scope.row.match_type === 2">
                  Contains
                </span>
                <span v-else-if="scope.row.match_type === 3">
                  Regex
                </span>
            </span>
            <span v-else-if="column.prop.toLowerCase() === 'return_type'">
                <span v-if="scope.row.return_type === 1">
                  To
                </span>
                <span v-else-if="scope.row.return_type === 2">
                  From
                </span>
                <span v-else-if="scope.row.return_type === 3">
                  Ordered
                </span>
            </span>
            <span v-else-if="column.prop.toLowerCase() === 'ignore_from_case'">
                {{ scope.row.ignore_from_case ? 'Yes' : 'No' }}
            </span>
            <span v-else-if="column.prop.toLowerCase() === 'action'">
                <el-button title="Edit" icon="el-icon-edit" @click="editMap(scope.row)"></el-button>
                <el-button title="Manage Pairs" icon="el-icon-set-up" @click="managePairs(scope.row.id)"></el-button>
            </span>
            <span v-else>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "MapIndex",
  props: ['extentId'],
  data() {
    return {
      maps: [],
      showModal: false,
      editingMap: null,
      events: {
        save: {
          label: "Save",
          event: "save"
        },
        cancel: {
          label: "Cancel",
          event: "cancel"
        }
      },
      columns: [
        {
          label: 'Name',
          prop: 'name',
          width: 275,
        },
        {
          label: 'Match Type',
          prop: 'match_type',
        },
        {
          label: 'Return Type',
          prop: 'return_type',
        },
        {
          label: 'Ignore From Case',
          prop: 'ignore_from_case',
        },
        {
          label: 'Default To',
          prop: 'default_to',
        },
        {
          label: 'Action',
          prop: 'action',
        },
      ]
    }
  },
  mounted() {
    this.fetchMaps();
  },
  methods: {
    async fetchMaps() {
      try {
        const { data } = await axios.get(`/api/extents/${this.extentId}/maps`);
        this.maps = data;
      } catch (error) {
        console.error(error);
      }
    },
    managePairs(mapId) {
      window.location.href = `/maps/${mapId}`;
    },
    createMap() {
      this.editingMap = null;
      this.showModal = true;
    },
    editMap(map) {
      this.editingMap = map;
      this.showModal = true;
    },
    async save(map) {
      try {
        if (map.id) {
          await axios.put(`/api/maps/${map.id}`, map);
        } else {
          await axios.post(`/api/extents/${this.extentId}/maps`, map);
        }
        await this.fetchMaps();
        this.showModal = false;
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>